import { m } from '@pricedrop/i18n';
import { itemsHref } from '@/routes/items/-search-params';

export type NavItem = {
  title: string;
  href: string;
};

export function getNavItems(): NavItem[] {
  return [
    { title: m.nav_lowestPrices(), href: itemsHref({ lowestPricesOnly: true }) },
    { title: m.nav_priceDrops(), href: itemsHref({ afterDropOnly: true }) },
    { title: m.nav_newItems(), href: itemsHref({ sort: 'date-desc' }) },
    { title: m.nav_backInStock(), href: itemsHref({ backInStockOnly: true }) },
    { title: m.nav_extension(), href: '/extension' },
    { title: m.nav_faq(), href: '/faq' },
  ];
}
